import { render, staticRenderFns } from "./deleteCollection.vue?vue&type=template&id=bb28abd0&scoped=true&"
import script from "./deleteCollection.vue?vue&type=script&lang=js&"
export * from "./deleteCollection.vue?vue&type=script&lang=js&"
import style0 from "./deleteCollection.vue?vue&type=style&index=0&id=bb28abd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb28abd0",
  null
  
)

export default component.exports